import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import { PaginatorModule } from 'primeng/paginator';
import { PaymentTerms, PaymentTermsGridResponse } from '../../../../model/administration.model';
import { AdministratorService } from '../../../../services/administrator.service';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { LoaderComponent } from '../../../loader/loader.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';


@Component({
  selector: 'app-list-payment-terms',
  standalone: true,
  imports: [SharedModule, CommonModule, PaginatorModule, LoaderComponent],
  templateUrl: './list-payment-terms.component.html',
  styleUrl: './list-payment-terms.component.scss'
})
export class ListPaymentTermsComponent {
  selectedPaymentTerms: PaymentTerms[] = [];
  paginator: boolean | undefined;

  constructor(private PaymentTermsService: AdministratorService, private route: Router, private confirmationService: ConfirmationService, private messageService: MessageService) { }
  @ViewChild('dt1') dt1: Table | undefined;
  PaymentTermses: PaymentTerms[] = [];
  start: number = 0;
  rowsPerPage: number = 10;
  searchKey: any;
  loader: boolean = false;
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }


  result: PaymentTermsGridResponse = {
    paymentTerms: [],
    totalRecords: 0
  }



  // pageRequest: gridPageRequest = {
  //   pageIndex: 0,
  //   pageSize: 20,
  //   id: 0
  // }

  // ngOnInit(): void {
  //   document.title = 'Payment Terms List';
  //   this.pageRequest.pageIndex = 0;
  //   this.pageRequest.pageSize = this.rowsPerPage
  //   this.searchEffect();
  //   this.getPaymentTerms(this.pageRequest);
  // }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 30,
    id: 0
  }

  ngOnInit(): void {
    document.title = 'Payment Terms List';
    this.getPaymentTerms(this.pageRequest);
    this.searchEffect();
  }


  paymenttermsResult: PaymentTerms[] = [];
  totalRecords: number = 0;
  getPaymentTerms(data: gridPageRequest): void {
    this.PaymentTermsService.getAllPaymentTerms(data).subscribe({
      next: (response: any) => {
        // console.log('API Response:', response);

        this.paymenttermsResult = response?.paymentTerms || [];
        this.totalRecords = response?.totalRecords || 0;

        // console.log('Payment Terms:', this.paymenttermsResult);
        // console.log('Total Records:', this.totalRecords);
        //this.loader = false;
      },
      error: (error: any) => {
        console.error('Error fetching payment terms:', error);
        this.paymenttermsResult = [];
        this.totalRecords = 0;
        //this.loader = false;
      }
    });
  }


  // getPaymentTerms(query: gridPageRequest) {
  //   this.PaymentTermsService.getAllPaymentTerms(query).subscribe({
  //     next: data => {
  //       this.result = data as PaymentTermsGridResponse;
  //       console.log(this.result.paymentTerms.length);

  //       this.pageCalculation();
  //     },
  //     error: error => {
  //       console.log(error);
  //     }
  //   });
  // }

  pageCalculation() {
    // this.pageRequest.pageSize = this.rowsPerPage;
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
    // this.paginationLabel = _.toString(this.pageRequest.pageIndex * this.pageRequest.pageSize) + (this.result.)
  }

  createPaymentTerms() {
    this.route.navigate(['/home/createPaymentTerm']);
  }

  editPaymentTerms(data?: any) {
    if (data) {
      this.route.navigate(['/home/createPaymentTerm'], { queryParams: { 'paymentTermsId': data }, skipLocationChange: true },);
    } else {
      this.route.navigate(['/home/createPaymentTerm'], { queryParams: { 'paymentTermsId': this.selectedPaymentTerms[0].paymentTermsId }, skipLocationChange: true },);
    }
  }

  // deletePaymentTerms() {
  //   if (this.selectedPaymentTerms && this.selectedPaymentTerms.length > 0) {
  //     var PaymentTermsIds = _.map(this.selectedPaymentTerms, 'paymentTermsId');
  //     this.PaymentTermsService.deletePaymentTerms(PaymentTermsIds).subscribe({
  //       next: data => {
  //         this.selectedPaymentTerms = [];
  //         this.getPaymentTerms(this.pageRequest);
  //       },
  //       error: error => {

  //       }
  //     });
  //   }
  // }

  // deletePaymentTerms() {
  //   if (this.selectedPaymentTerms && this.selectedPaymentTerms.length > 0) {
  //     this.confirmationService.confirm({
  //       header: 'Are you sure?',
  //       message: 'Please confirm to proceed.',
  //       accept: () => {
  //         var paymentTermsIds = _.map(this.selectedPaymentTerms, 'paymentTermsId');
  //         this.loader = true;
  //         this.PaymentTermsService.deletePaymentTerms(paymentTermsIds).subscribe({
  //           next: () => {
  //             this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PaymentTerms deleted successfully.' });
  //             this.selectedPaymentTerms = [];
  //             this.getPaymentTerms(this.pageRequest);
  //             this.loader = false;
  //           },
  //           error: error => {
  //             this.loader = false;
  //             console.error(error);
  //           }
  //         });
  //       },
  //       reject: () => {
  //         // User rejected, do nothing
  //       }
  //     });
  //   }
  // }

  deletePaymentTerms() {
    if (this.selectedPaymentTerms && this.selectedPaymentTerms.length > 0) {
      this.confirmationService.confirm({
        header: 'Are you sure?',
        message: 'Please confirm to proceed.',
        accept: () => {
          const paymentTermsIds = this.selectedPaymentTerms
            .map(x => x.paymentTermsId);

          this.loader = true;

          this.PaymentTermsService.deletePaymentTerms(paymentTermsIds).subscribe({
            next: () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Payment Terms deleted successfully.'
              });

              this.selectedPaymentTerms = [];
              this.getPaymentTerms(this.pageRequest);
              this.loader = false;
            },
            error: (error) => {
              this.loader = false;

              const message =
                error?.error?.message ||
                'Payment Terms cannot be deleted because it is already used.';

              this.messageService.add({
                severity: 'warn',
                summary: 'Delete blocked',
                detail: message
              });
            }


          });
        }
      });
    }
  }


  //onPrevious() {
  //  this.pageRequest.pageIndex = this.pageRequest.pageIndex - 1;
  // this.getPaymentTerms(this.pageRequest);
  //}

  //onNext() {
  //  this.pageRequest.pageIndex = this.pageRequest.pageIndex + 1;
  //  this.getPaymentTerms(this.pageRequest);
  //}


  //code added here
  loadpayments(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchPayment();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getPaymentTerms(this.pageRequest);
    }
  }
  searchPayment() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    // this.loader = true;

    this.PaymentTermsService.autoSearchPayment(this.searchKey).subscribe(
      (data: any) => {

        if (Array.isArray(data)) {
          this.result.paymentTerms = data;

          this.pageRequest.pageSize = this.result.paymentTerms.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.paymentTerms.length,
          };
          this.paginator = false;
        }
        else if (data && Array.isArray(data.paymentTerms)) {
          this.result.paymentTerms = data.paymentTerms;

          this.pageRequest.pageSize = this.result.paymentTerms.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.paymentTerms.length,
          };
          this.paginator = false;
        }
        else {
          this.result.paymentTerms = [];
        }

        // this.loader = false;
      },
      (error: any) => {
        console.error('Search error:', error);
        // this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
      }
    );
  }
  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getPaymentTerms(this.pageRequest);
  }



  placeholder: string = 'Search By ';
  private messages: string[] = ['Payment Terms Code', 'Discount', 'Conditional Discount', 'Net Due', 'Description'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }
}